// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Fpf33uABfyN9nfRlTL5P {
    display: flex;
    height: 100%;
    padding: 0 !important;

    & .k18KBCCSmJOMlhjKr6tN {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        gap: 16px;
        padding: 24px;
    }
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Home/HomeActionItem/HomeActionitem.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;;IAErB;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,8BAA8B;QAC9B,SAAS;QACT,aAAa;IACjB;AACJ","sourcesContent":[".card {\n    display: flex;\n    height: 100%;\n    padding: 0 !important;\n\n    & .cardActionArea {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: space-between;\n        gap: 16px;\n        padding: 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `Fpf33uABfyN9nfRlTL5P`,
	"cardActionArea": `k18KBCCSmJOMlhjKr6tN`
};
export default ___CSS_LOADER_EXPORT___;
